import type { IParagraphEntry } from "~/models/IUserEntry";

export function useSaveEntry<T extends IParagraphEntry>(
  entry: MaybeRefOrGetter<T>
) {
  const toast = useToast();
  const { t } = useI18n();
  const { updateEntry } = useEntries();
  const updatingEntry = ref(false);

  const handleSave = async (payload: Partial<T>) => {
    updatingEntry.value = true;
    try {
      await updateEntry({ ...toValue(entry), ...payload });
    } catch (_e) {
      toast.error(
        t("legal_text.textEditor.errors.content_could_not_be_changed")
      );
    } finally {
      updatingEntry.value = false;
    }
  };

  return {
    handleSave,
    updatingEntry,
  };
}
